import type {GridColDef} from "@mui/x-data-grid-premium";
import type {ExcelDataColumns} from "~/services/ApiTypes";

const ADDRESS_COLUMNS: ExcelDataColumns[] = [
    {model: 'data_source.supplier', field: 's_address', title: 'Supplier Address'},
    {model: 'data_source.supplier', field: 's_postal', title: 'Supplier Postal Code'},
    {model: 'data_source.supplier', field: 's_city', title: 'Supplier City'},
    {model: 'data_source.supplier', field: 's_country', title: 'Supplier Country'},
    {model: 'data_source.supplier', field: 's_region', title: 'Supplier Region'},
];

const NOT_EXPORTED = ['parent_spend', 'p_src_databag_id', 'context_menu_action'];

/** The Excel headers stay as they were before the redesign */
function excelTitle(column: GridColDef, isSynergy: boolean): string {
    switch (column.field) {
        case 's_name':
            return 'Supplier Name';
        case 's_country_code':
            return 'Supplier Country';
        case 'total_spend':
            return isSynergy ? 'Supplier Category Spend' : 'Total spend';
        default:
            return column.headerName ?? column.field;
    }
}

function toExcelColumns(columns: GridColDef[], isSynergy: boolean): ExcelDataColumns[] {
    return columns.filter(c => !NOT_EXPORTED.includes(c.field)).map(c => ({field: c.field, title: excelTitle(c, isSynergy)}));
}

/** Excel export of the supplier table: its columns plus the supplier address */
export function supplierBreakdownExcelColumns(columns: GridColDef[], isSynergy: boolean): ExcelDataColumns[] {
    return [...toExcelColumns(columns, isSynergy), ...ADDRESS_COLUMNS];
}

/** Excel export of the business unit pivot, with the supplier address after the supplier name */
export function businessUnitPivotExcelColumns(columns: GridColDef[], isSynergy: boolean): ExcelDataColumns[] {
    const result = toExcelColumns(columns, isSynergy);
    const supplierName = result.findIndex(c => c.field === 's_name');
    result.splice(supplierName === -1 ? result.length : supplierName + 1, 0, ...ADDRESS_COLUMNS);
    return result;
}
